module.exports = __webpack_public_path__ + "media/icons/pdf-file@2x-ca8f1f6d.png";